import { configure } from 'vee-validate';

export default {
  install(_app) {
    configure({
      // Form validation behavior
      validateOnBlur: true, // validate when input loses focus
      validateOnChange: false, // validate when value changes
      validateOnInput: false, // skip validation on each keystroke (can enable if you prefer)
      validateOnModelUpdate: true, //  Vuetify’s v-model updating on each keystroke, that setting will trigger validation
    });
  },
};
